import { render, staticRenderFns } from "./DemoMonthPickerReadonlyAndDisabled.vue?vue&type=template&id=5aeaf1a4&"
import script from "./DemoMonthPickerReadonlyAndDisabled.vue?vue&type=script&lang=js&"
export * from "./DemoMonthPickerReadonlyAndDisabled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDatePicker,VRow})
